<template>
  <div class="depositDetailsPage">
    <headerNotice routerName="预存款流水统计"></headerNotice>
   
    <!-- 搜索条 -->
    <div class="searchBox">
      <el-form :inline="true" :model="depositDetailsSearchForm" class="demo-form-inline searchForm">
        <el-form-item style="margin-right:40px;"  label="客户名称">
          <el-input v-model="depositDetailsSearchForm.Word" clearable placeholder="请输入客户名称">
            <el-button type="primary" slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-right:40px;" label="客户地址">
          <el-cascader
            ref="regin"
            v-loading="regionLoading"
            placeholder="地址搜索"
            :options="AllAreaOptions"
            :props="cascaderProps"
            @change="AreaHandleChange"
            change-on-select
          ></el-cascader>
        </el-form-item>
        <el-form-item  style="margin-right:40px;" label="流水类型">
          <el-select v-model="depositDetailsSearchForm.fundType" clearable placeholder="请选择流水类型" @change="onSearch">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="余额充值" :value="1"></el-option>
            <el-option label="余额消费" :value="2"></el-option>
            <el-option label="系统充值" :value="6"></el-option>
            <el-option label="微信消费" :value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-right:40px;"  label="交易时间">
          <el-date-picker
            @change="durationChange"
            style="width:240px;"
            v-model="duration"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
		<el-form-item label="所属业务员">
		  <el-select filterable  v-model="depositDetailsSearchForm.salesman" placeholder="请选择商品标签">
		    <el-option label="全部" :value="0"></el-option>
		    <el-option
		      v-for="item in salesmanList"
		      :key="item.userId"
		      :label="item.realName"
		      :value="item.userId"
		    ></el-option>
		  </el-select>
		</el-form-item>
		  <el-form-item label="所属仓库">
		    <el-select filterable  v-model="depositDetailsSearchForm.houseID" placeholder="请选择所属仓库">
		      <el-option label="全部" :value="0"></el-option>
		      <el-option
		        v-for="item in houseList"
		        :key="item.houseList"
		        :label="item.houseName"
		        :value="item.houseID"
		      ></el-option>
		    </el-select>
		  </el-form-item>
        <el-form-item style="margin-right:40px;"  label="共计金额">
          <el-input v-model="depositDetailsTableData[0].allMoney" disabled></el-input>
        </el-form-item>    
        <el-form-item >
         <el-button type="primary"  @click="onExport">导出</el-button> 
         </el-form-item>    
      </el-form>
     
    </div>
     
    <!-- 搜索结果列表 -->
    <div class="searchList">
      <div class="searchListContent">
        <el-table
          ref="searchListTable"
          :data="depositDetailsTableData"
          style="width: 100%"
          border
          v-loading="loading"
        >
          <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
          <el-table-column align="center" prop="customerName" label="客户名称"></el-table-column>
          <el-table-column align="center" prop="customerAddress" label="客户地址"></el-table-column>
          <el-table-column align="center" prop="linkman" label="联系人"></el-table-column>
          <el-table-column align="center" prop="phone" label="手机"></el-table-column>
		  <el-table-column align="center" prop="houseName" label="仓库"></el-table-column> 
		   <el-table-column align="center" prop="salesman" label="业务员"></el-table-column> 
		    <el-table-column align="center" prop="orderCode" label="订单号"></el-table-column>
          <el-table-column align="center" prop="balance" label="预存款金额(￥)">
            <template slot-scope="scope">
              <span
                class="detialSpan"
                @click="onAmountOfAdvanceDeposit(scope.row,scope.$index)"
              >{{scope.row.balance}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="fundRecordBalance" label="余额变动"></el-table-column>
          <el-table-column align="center" prop="phone" label="流水类型">
            <template slot-scope="scope">
              <span v-if="scope.row.fundType==1">余额充值</span>
              <span v-if="scope.row.fundType==2">余额消费</span>
              <span v-if="scope.row.fundType==6">系统充值</span>
              <span v-if="scope.row.fundType==8">微信消费</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="createTime" label="交易时间"></el-table-column>
        </el-table>
      </div>
      <!--搜索列表分页-->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      loading: true,
      totalCount: 0, //总数据条数
      maxResultCount: 10, //默认一页显示的个数,
      currentPage: 1,
      baseUrl: this.$store.state.ossUrl,
      depositDetailsSearchForm: {
        //搜索表单
        Word: ""
      },
	   houseList: [],//所属仓库
      depositDetailsTableData: [], //表单数据
      salesmanList: [], //业务员列表
      AllAreaOptions: [], //客户地址
      regionLoading: true,
      cascaderProps: {
        children: "children",
        label: "name",
        value: "code"
      },
      duration: [],
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas({
      MaxResultCount: this.maxResultCount
    });
    this.getAllRegin();
	this.getSalesmanList();
	this.getSelectData();
  },
  methods: {
	  //获取下拉数据
	  getSelectData() {
		  let self = this;
		  $http.GET({
			  url: this.$store.state.apiUrl + "/api/services/app/Warehouse/GetAllWareHouse",
			  success(res) {
				  self.houseList = res;
			  },
			  fail(res) {
			  }
		  })
	  },
	  //获取业务员列表
	  getSalesmanList() {
	    let self = this;
	    self.loading = true;
	    $http.GET({
	      url:
	        this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetList",
	      params: {
	        MaxResultCount: 999
	      },
	      success(res) {
	        self.salesmanList = res.items;
	      },
	      fail(res) {}
	    });
	  },
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminStatistics/GetStatisticsByBalance",
        params: params,
        success(res) {
          self.depositDetailsTableData = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },
    onAmountOfAdvanceDeposit(row) {
      sessionStorage.setItem("moneyDetialForm", JSON.stringify(row));
      this.$router.push({
        path: "/amountOfAdvanceDepositDetails",
        query: {
          goodsId: "balance",
          userId: row.userID
        }
      });
    },
    //搜索
    onSearch(params) {
      let self = this;
      let form = this.depositDetailsSearchForm;
      form.SkipCount = 0;
      this.getDatas(form);
      this.currentPage = 1;
    },
     // 导出Excel
    onExport() {

      let params = this.depositDetailsSearchForm;
      params.SkipCount = 0;
      params.MaxResultCount = 60000;
      params.token=localStorage.getItem('accessToken');
      let search = '?'
      for(let key in params) {
        if(params[key] || params[key] === 0) {
          search += key + '=' + params[key] + '&'
        }
      }
      
      search = search.substring(0, search.length - 1)
      window.open(
        this.$store.state.apiUrl + 
        '/Export/ExportStatisticsByBalance' + search
      )
    },
    //搜索列表一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let  params = this.depositDetailsSearchForm;
      params.MaxResultCount = this.maxResultCount;
      this.getDatas(params);
    },
    //搜索列表跳转到指定页
    handleCurrentChange(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = this.depositDetailsSearchForm;
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      this.getDatas(params);
    },
    //获取所有省市区数据
    getAllRegin() {
      let self = this;
      self.regionLoading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/Province/GetAllRegion",
        success(res) {
          self.reginData = res;
          let allRegin = {
            name: "全部",
            code: null,
            children: []
          };

          self.AllAreaOptions = [allRegin, ...res];
          self.regionLoading = false;
        },
        fail(res) {
          self.regionLoading = false;
        }
      });
    },
    //下拉选择省市事件
    AreaHandleChange(value) {
      debugger;
      let self = this;
      self.depositDetailsSearchForm.areaCode = "";
      if (value.length == 3) {
        self.depositDetailsSearchForm.areaCode = value[2];
      }
      let params = self.depositDetailsSearchForm;
      params.maxResultCount = self.maxResultCount;
      params.skipCount = 0;
      self.getDatas(params);
    },

    // 根据时间搜索
    durationChange(val) {
      if (!val) {
        val = [];
      }
      debugger;
      this.depositDetailsSearchForm.startTime = val[0];
      this.depositDetailsSearchForm.endTime = val[1];
      let params = this.depositDetailsSearchForm;
      params.skipCount = 0;
      this.getDatas(params);
    },
  }
};
</script>

<style lang='scss' scoped>
.depositDetailsPage {
  //搜索框
  .searchBox {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    .searchForm {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 20px;
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  //搜索列表
  .searchList {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    .searchListHead {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding-left: 20px;
      background: #efefef;
      border-bottom: 1px solid #c5c5c5;

      .searchListCtl {
        button,
        .el-select {
          width: 130px;
          margin-left: 10px;
        }
      }
    }
    .searchListContent {
      .detialSpan {
        color: #ff9400;
        cursor: pointer;
      }
      .moneyColor {
        color: #3498db;
        // cursor: pointer;
      }
    }
  }
}
</style>
